import request from '@/utils/request'

export function contentus(query) {
    return request({
        url: '/website/websitehome/contentus/'+query.id,
        method: 'get',
        params: query
    })
}

export function companyinfo(query) {
    return request({
        url: '/website/websitehome/companyinfo/'+query.id,
        method: 'get',
        params: query
    })
}
